import { render, staticRenderFns } from "./Admin.vue?vue&type=template&id=796185dd"
import script from "./Admin.vue?vue&type=script&lang=js"
export * from "./Admin.vue?vue&type=script&lang=js"
import style0 from "./Admin.vue?vue&type=style&index=0&id=796185dd&prod&lang=scss&soped=true"
import style1 from "./Admin.vue?vue&type=style&index=1&id=796185dd&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports